var _a;
import { BuildingType as ServerBuildingType } from '@api-gen';
import { createDataRecordConverter } from '@core/utils/helpers';
import { BuildingType as ClientBuildingType } from '@features/guidbooks/types';
export var buildingTypeMap = createDataRecordConverter((_a = {},
    _a[ClientBuildingType.ResidentialBuildings] = ServerBuildingType.ResidentialBuildings,
    _a[ClientBuildingType.Hotel] = ServerBuildingType.Hotel,
    _a[ClientBuildingType.AdministrativeBuildings] = ServerBuildingType.AdministrativeBuildings,
    _a[ClientBuildingType.Hospital] = ServerBuildingType.Hospital,
    _a[ClientBuildingType.EducationalInstitutions] = ServerBuildingType.EducationalInstitutions,
    _a[ClientBuildingType.PreschoolEducationalInstitutions] = ServerBuildingType.PreschoolEducationalInstitutions,
    _a));
export var convertToServerBuildingTypeData = function (type) {
    return buildingTypeMap.toServer[type];
};
export var convertToClientBuildingTypeData = function (type) {
    return buildingTypeMap.toClient[type];
};
